import { useIntl } from 'react-intl';

export function useSOBannerDetailLang() {
  const { formatMessage } = useIntl();

  return {
    getBannerText: (date: string, time: string) =>
      formatMessage({ id: 'scheduleOrder.detail.bannerText' }, { date, time }),
  };
}
